"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTokenUpdateService = void 0;

var _rxjs = require("rxjs");

var _auth = require("../constants/auth.constants");

var _auth2 = require("../store/auth.actions");

var createTokenUpdateService = function createTokenUpdateService(store) {
  var updateInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _auth.TOKEN_CHECKING_INTERVAL;
  var timer = (0, _rxjs.interval)(updateInterval);
  return timer.subscribe(function () {
    return store.dispatch((0, _auth2.checkAccessTokenBySchedule)());
  });
};

exports.createTokenUpdateService = createTokenUpdateService;